export default __webpack_public_path__ + "static/media/ill-no-classes-assigned.c6de3652.svg";